import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {trigger, style, animate, transition, state} from '@angular/animations';
import { Router } from '@angular/router';
import { ReportService } from '../../core/http/report.service'

import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-create-param',
  templateUrl: './create-param.component.html',
  styleUrls: ['./create-param.component.scss']
})
export class CreateParamComponent implements OnInit {

  isLoading = false;
  Errors;
  success: any = [];
  data: any = [];
  types: any = [];
  params: any = [];
  template: any = [];
  buiders: any = [];
  return: any = [];
  
  constructor(public report:ReportService,  private _snackBar: MatSnackBar) { }

  ngOnInit(): void {

    this.report
    .getReportParamTypes()
    .subscribe(
      (resSuccess) => {

        this.data = resSuccess
        this.params = this.data.Result
        console.log(this.data)
      },
      (resErr) => {
        this.Errors = resErr;
      }
    ); 

    this.report
    .getReportLookUpTypes()
    .subscribe(
      (resSuccess) => {

        this.types = resSuccess
        // this.types = this.return.result
        console.log(this.types)
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );

    this.report
    .getReportTemplate()
    .subscribe(
      (resSuccess) => {

        this.template = resSuccess
        this.buiders = this.template.Result
        // console.log(this.template)
      },
      (resErr) => {
        this.Errors = resErr;
      }
    ); 
  }

  Form = new FormGroup({
    reportBuilderTemplateId: new FormControl(''),
    name: new FormControl(''),
    parameterType: new FormControl(''),
    id: new FormControl(0),
  });

  onSubmit(e) {
    e.preventDefault();
      this.isLoading = true;
      this.Errors = null;
      console.log(this.Form.value)
      const {
        reportBuilderTemplateId,
        name,
        parameterType,
        id,
      } = this.Form.value;
      console.log(this.Form.value)
      this.report
        .createReportParam(
          reportBuilderTemplateId,
          name,
          parameterType,
          id,
        )
        .subscribe(
          (resSuccess) => {
  
            this.success = resSuccess
            this.isLoading = false;
            console.log(resSuccess)
            console.log(this.success)
  
            if (this.success) {

              if (!this.success.hasError) {
                this._snackBar.open('Created Succesfully', '', {
                  duration: 2000,
                  verticalPosition: 'top',
                });
                this.Form.reset()
              }
              else {
                this._snackBar.open('Error: Please try again', '', {
                  duration: 2000,
                  verticalPosition: 'top',
                });
              }
            }
            else {
              this.Errors = "Not successful, please try again"
              this._snackBar.open('Error: Please try again', '', {
                duration: 2000,
                verticalPosition: 'top',
              });     
              console.log(resSuccess)
            }
            
          },
          (resErr) => {
            this.isLoading = false; 
            this.Errors = resErr;
            console.log(resErr)
          }
        );
  }

}
